// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1OYvy","approved":"Status_approved__NCZmi","rejected":"Status_rejected__d4F3Z","expired":"Status_expired__tvSs_","label":"Status_label__3NxsQ"};